let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ei105")).then(() => parcelRequire('kpHCz'));